// Local
export const PAGES_PUBLIC_PATH = `..${process.env.PUBLIC_URL}/assets/pages`;

export const IMAGES_PUBLIC_PATH = `..${process.env.PUBLIC_URL}/assets/images`;

// Prod
// export const PAGES_PUBLIC_PATH =
//   "https://kaplantm.github.io/atlantica/assets/pages"; // prod

// export const IMAGES_PUBLIC_PATH =
//   "https://kaplantm.github.io/atlantica/assets/images"; // prod
